// nom-logement-facture.js — le nom du logement qui se FIGE sur une facture,
// un reçu voyageur (29/09) ou un CONTRAT de location (30/09) — décisions
// Dimitri, chemin de l'argent et document juridique.
//
// Deux défauts, tous deux latents au 29/09 (vérifié en base : aucune pièce
// touchée) :
//   1. Une chambre de sous-location était fusionnée avec sa maison
//      (`{ ...maison, ...chambre }`) : si la chambre n'avait pas de nom
//      complet et que la maison en avait un, la facture de la CHAMBRE
//      portait le nom de la MAISON — figé à jamais (pièce émise immuable).
//   2. Sans aucun nom, le repli figeait l'identifiant technique (« lc1 »).
// Désormais : le nom vient TOUJOURS du logement lui-même, et sans nom
// l'émission (ou la génération du contrat) est REFUSÉE avec une raison
// visible. Une pièce ne disparaît jamais en silence.
//
// ⚠️ SOURCE UNIQUE (pas un miroir) : CJS pur, zéro dépendance, consommé
//   - côté CLIENT (FactureTab, FicheDocsCtrl, ContratTab, ResaV2Modal,
//     src/lib/contrat-html.js, src/lib/contrat-vars.js) — CRA gère le CJS ;
//   - côté SERVEUR via le shim lib/nom-logement-facture.js (contrat signé,
//     PDF archivé). Même sens que sms-validator : CRA interdit src/ → lib/,
//     le require lib/ → src/ est légal (Node, Jest, trace Vercel nft).

/** Le nom propre du logement, ou null. Jamais celui du parent, jamais l'id. */
function nomLogementFacture(log) {
  // Chaque champ nettoyé AVANT le choix : un nom complet fait d'espaces ne
  // doit pas masquer un nom valide.
  const propre = (v) => (typeof v === "string" ? v.trim() : "");
  return propre(log && log.nom_complet) || propre(log && log.nom) || null;
}

/**
 * Le logement tel que la pièce le voit : adresse, codes, contact hérités de
 * la maison (inchangé), mais NOM et NOM COMPLET de la chambre seule.
 */
function logPourFacture(log, parentLog = null) {
  const base = parentLog ? { ...parentLog, ...log } : log;
  if (!base) return base;
  return { ...base, nom: (log && log.nom) || null, nom_complet: (log && log.nom_complet) || null };
}

// Le cœur de la phrase est COMMUN aux factures et aux contrats : même geste
// demandé à Dimitri, même endroit où le faire.
const CONSIGNE_NOM = "ce logement n'a pas de nom. Renseigne-le dans Instructions › Nom du logement, puis réessaie.";

const RAISON_SANS_NOM =
  "Émission refusée : " + CONSIGNE_NOM + " Aucun numéro de facture n'a été consommé.";

const RAISON_CONTRAT_SANS_NOM = "Contrat refusé : " + CONSIGNE_NOM;

module.exports = {
  nomLogementFacture,
  logPourFacture,
  RAISON_SANS_NOM,
  RAISON_CONTRAT_SANS_NOM,
};
